var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left container edit-user-form"},[_vm._v("\n  Select user to edit\n  "),_c('b-select',{attrs:{"options":_vm.users},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}}),_vm._v(" "),(_vm.user.hasOwnProperty('id'))?_c('EditUser',{attrs:{"user":_vm.user}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0dd738","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/users/Index.vue
// module id = null
// module chunks = 